export const postData = async (url, formData) => {

  const token = localStorage.getItem('token')

  let result = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(formData)
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((error) => console.log('GET_DATA_ERROR: ', error));
  return result;
};
  